import { HttpClient } from 'api/http-client';
import { CitationResponse } from 'queries/citation';

class CitationClient extends HttpClient {
  public getCitation(id: number | string): Promise<CitationResponse> {
    return this.get(`/citations?citationUuid=${id}`);
  }
}

export const CitationAPI = new CitationClient();
